// prettier-ignore
export const EXTERNAL_LINKS = {
  aws_console: 'https://console.aws.amazon.com',
  gcp_console: 'https://console.cloud.google.com',
  azure_console: 'https://portal.azure.com',
  jq: 'https://stedolan.github.io/jq/',
  castai_terraform: 'https://registry.terraform.io/providers/CastAI/castai/latest',
  castai_slack_community: 'https://join.slack.com/t/castai-community/shared_invite/zt-nwtbsbqq-dWOBiUgLtIGMsUSup7Xksw',
  castai_landing: '',
  castai_book_demo: 'https://cast.ai/book-a-demo/',
  castai_pricing: 'https://cast.ai/pricing/',
  castai_contact_us: 'https://cast.ai/contact-us/',
  castai_kubernetes_cost_benchmark: 'https://cast.ai/kubernetes-cost-benchmark/',
  docs_agent: 'https://github.com/castai/k8s-agent',
  docs_dbo_rds_enabling_performance_insights: 'https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/USER_PerfInsights.Enabling.html',
  external_docs_docker_deamon_config: 'https://docs.docker.com/engine/reference/commandline/dockerd/#daemon-configuration-file',
  external_docs_kubelet_config: 'https://kubernetes.io/docs/reference/config-api/kubelet-config.v1beta1/#kubelet-config-k8s-io-v1beta1-KubeletConfiguration',
  external_docs_read_only_agent: 'https://cast.ai/blog/how-does-the-read-only-cast-ai-agent-work-and-what-data-can-it-read/',
  external_docs_nsa_cisa: 'https://www.nsa.gov/Press-Room/Cybersecurity-Advisories-Guidance/smdsearch11747/kubernetes/',
  external_docs_pod_security: 'https://kubernetes.io/docs/concepts/security/pod-security-standards/',
  external_docs_cis: 'https://www.cisecurity.org/benchmark/kubernetes',
  external_docs_cvss_vector: 'https://www.first.org/cvss/specification-document#Vector-String',
  external_docs_cvss: 'https://www.first.org/cvss/specification-document#Qualitative-Severity-Rating-Scale',
  external_docs_cvss_score: 'https://www.first.org/cvss/v3.1/specification-document',
  external_docs_graviton: 'https://docs.aws.amazon.com/whitepapers/latest/aws-graviton-performance-testing/what-is-aws-graviton.html',
  external_docs_metrics_server: 'https://github.com/kubernetes-sigs/metrics-server',
  external_docs_metrics_server_download: 'https://github.com/kubernetes-sigs/metrics-server/releases/latest/download/components.yaml',
  external_docs_instance_metadata: 'https://docs.aws.amazon.com/elasticbeanstalk/latest/dg/environments-cfg-ec2-imds.html',
  external_docs_eks_control_plane_costs: 'https://aws.amazon.com/about-aws/whats-new/2024/04/amazon-eks-support-kubernetes-versions/',
  external_huggingface: 'https://huggingface.co',
  external_huggingface_tokens: 'https://huggingface.co/settings/tokens',
  aie_to_kimchi: 'https://kimchi.dev/castai-users',
  castai_new_console_experience: 'https://cast.ai/blog/new-cast-ai-console-experience/',
};
